import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";

import CountryCode from "../../countryCode";
import Dialog from "../../dialog";
// import GoogleMapComponent from '../../googleMap';
import MapComponent from "../../leafletMap";
import Snackbar from "../../snackbar";
import { styles } from "./styles";
import InputAddress from "../../suggestAddress";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import InputFormat from "../../../partials/inputForm";

// Component
// style
class CreateBranch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkValidate: "",
      branch: {
        city: "hochiminh",
        district: "",
        phone: "",
        mobile: "",
        branchName: "",
        address: "",
        addressData: "",
        lat: 10.797336,
        lng: 106.679428,
        countryCode: this.props.defaultCountryCode || "+84",
      },
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOpenDialog = this.handleOpenDialog.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.defaultCountryCode !== this.props.defaultCountryCode &&
      !this.props.defaultCountryCode
    ) {
      let { branch } = this.state;
      branch.countryCode = nextProps.defaultCountryCode;
      this.setState({ branch: branch });
    }
  }
  handleOpenSnackBar = (message, type) => {
    this.mSnackbar.handleClick(message, type);
  };

  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let branch = this.state.branch;
    branch[name] = value;
    this.setState({ branch }, function () {});
  };
  handleChangeAddress = (value) => {
    let { branch } = this.state;
    branch = { ...branch, ...value };
    this.setState({ branch });
  };
  handleSubComponentChange = (name, value) => {
    let branch = this.state.branch;
    branch[name] = value;
    this.setState({ branch });
  };

  async handleOpenDialog() {
    let branch = this.state.branch;
    let { t } = this.props;
    if (!branch.branchName) {
      this.mSnackbar.handleClick(
        t("servicebranch_createbranch_fill_in_branch_name"),
        "warning"
      );
    } else if (!branch.mobile) {
      this.mSnackbar.handleClick(
        t("servicebranch_createbranch_fill_in_branch_mobile"),
        "warning"
      );
    } else if (!branch.addressData) {
      this.mSnackbar.handleClick(
        t("servicebranch_createbranch_fill_in_branch_address"),
        "warning"
      );
    } else if (!branch.address) {
      this.mSnackbar.handleClick(
        t("servicebranch_createbranch_fill_in_branch_address_to_show_on_map"),
        "warning"
      );
    } else if (!_parsePhoneNumber(branch.countryCode, branch.mobile).isValid) {
      this.mSnackbar.handleClick(
        t("servicebranch_createbranch_please_enter_valid_phone"),
        "warning"
      );
    } else {
      await this.myGoogleMap.viewOnGoogleMap(branch.address);
      if (this.myGoogleMap.state && this.myGoogleMap.state.checked) {
        this.handleSubmit();
      } else {
        this.mSnackbar.handleClick(
          t("servicebranch_createbranch_address_invalid"),
          "warning"
        );
      }
    }
  }

  onEnterAddress = (event) => {
    if (event.key === "Enter") {
      const { branch = {} } = this.state;
      this.myGoogleMap.viewOnGoogleMap(branch.address);
    }
  };
  async handleSubmit() {
    let { t } = this.props;
    const _this = this;
    // this.mDialog.handleDialogClose()
    let { branch = {} } = this.state;
    branch.address = branch.addressData || "";
    delete branch.addressData;
    let check = await this.props.serviceBranchDispatch.createBranchForRole({
      data: branch,
    });
    if (check.code === 1) {
      this.mSnackbar.handleClick(
        t("servicebranch_createbranch_create_successfully")
      );
      this.props.serviceBranchDispatch.getBranchForOwner({ serviceCode: "" });
      setTimeout(function () {
        _this.props.addNewBranch();
      }, 2000);
    } else {
      this.mSnackbar.handleClick(
        t("servicebranch_createbranch_create_unsuccessfully") +
          " " +
          check.message,
        "error"
      );
    }
  }

  render() {
    const { classes, theme, t } = this.props;
    return (
      <Paper className={classes.root}>
        <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
        {/* <Dialog
                    onRef={dialog => (this.mDialog = dialog)} 
                    disagree={t("servicebranch_createbranch_cancel")} 
                    agree={t("servicebranch_createbranch_create")} 
                    title = {t("servicebranch_createbranch_confirm")}
                    content={t("servicebranch_createbranch_create_new_branch_for_your_spa")}
                    action={this.handleSubmit}
                /> */}
        <form className={classes.container} noValidate autoComplete="off">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  <InputFormat
                    required
                    label={t("servicebranch_createbranch_branch_name")}
                    name="branchName"
                    // margin="normal"
                    value={this.state.branch.branchName}
                    onChange={this.handleChange}
                  />
                </Grid>

                <Grid item xs={12} sm={4}>
                  <Grid
                    container
                    spacing={3}
                    justify="center"
                    alignItems="flex-end"
                  >
                    <Grid item xs={4} sm={4}>
                      <CountryCode
                        // margin="normal"
                        code={this.state.branch.countryCode}
                        handleCountryCode={this.handleSubComponentChange}
                      />
                    </Grid>
                    <Grid item xs={8} sm={8}>
                      <InputFormat
                        required
                        label={t("servicebranch_createbranch_mobile")}
                        name="mobile"
                        // margin="normal"
                        value={this.state.branch.mobile}
                        onChange={this.handleChange}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputFormat
                    label={t("servicebranch_createbranch_phone")}
                    name="phone"
                    // margin="normal"
                    value={this.state.branch.phone}
                    onChange={this.handleChange}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <InputFormat
                    required
                    label={t("servicebranch_createbranch_address")}
                    name="addressData"
                    value={this.state.branch.addressData || ""}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <InputAddress
                    label={t("servicebranch_editbranch_suggest_address")}
                    onKeyPress={this.onEnterAddress}
                    required
                    name="address"
                    value={this.state.branch.address || ""}
                    handleChange={this.handleChangeAddress}
                    // className={classes.textField}
                    auto={false}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <InputFormat
                    disabled
                    required
                    label={t("servicebranch_editbranch_longitude")}
                    // margin="normal"
                    name="country"
                    value={this.state.branch.lng || ""}
                    className={classes.textField}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <InputFormat
                    required
                    disabled
                    label={t("servicebranch_editbranch_latitude")}
                    // margin="normal"
                    name="country"
                    value={this.state.branch.lat || ""}
                    className={classes.textField}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <InputFormat
                    disabled
                    label={t("service_ownerspa_servicedetail_feature_country")}
                    name="country"
                    value={this.state.branch.country || ""}
                    // margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <InputFormat
                    disabled
                    label={t("service_ownerspa_servicedetail_feature_state")}
                    name="state"
                    // margin="normal"
                    value={this.state.branch.state || ""}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <InputFormat
                    disabled
                    label={t("servicebranch_createbranch_city")}
                    value={this.state.branch.city || ""}
                    name="district"
                    // margin='normal'
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <InputFormat
                    disabled
                    label={t("servicebranch_createbranch_district")}
                    value={this.state.branch.district || ""}
                    name="district"
                    // margin='normal'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <MapComponent
                    onRef={(googleMap) => (this.myGoogleMap = googleMap)}
                    handleChangeAddress={this.handleChangeAddress}
                    handleOpenSnackBar={this.handleOpenSnackBar}
                    lat_center={Number(this.state.branch.lat || 0)}
                    lng_center={Number(this.state.branch.lng || 0)}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleOpenDialog}
                    className={classes.button}
                  >
                    {t("servicebranch_createbranch_save")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Paper>
    );
  }
}

CreateBranch.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  serviceState: state.service,
  defaultCountryCode: state.setting.setting
    ? state.setting.setting.defaultCountryCode
    : "+84",
});

const mapDispatch = (dispatch) => ({
  serviceBranchDispatch: dispatch.serviceBranch,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(CreateBranch)
  )
);
